
export class ProductMeasureGroupFilterOptions {
    productId: number;
    measureGroupIds: Array<number>;
}
